import React from 'react';
import TaskNode from '../ui/atoms/TaskNode';

const TASK_GRAPH_CONFIG = {
  automaticRearrangeAfterDropNode: false,
  collapsible: false,
  directed: true,
  focusAnimationDuration: 0.75,
  focusZoom: 1,
  height: 400,
  highlightDegree: 1,
  highlightOpacity: 0.2,
  linkHighlightBehavior: true,
  maxZoom: 8,
  minZoom: 0.1,
  nodeHighlightBehavior: true,
  panAndZoom: false,
  staticGraph: false,
  width: 800,
  d3: {
    alphaTarget: 0.05,
    gravity: -300,
    linkLength: 300,
    linkStrength: 1
  },
  node: {
    mouseCursor: 'pointer',
    renderLabel: false,
    size: 800,
    viewGenerator: node => <TaskNode node={node} />
  },
  link: {
    color: '#d3d3d3',
    fontColor: 'black',
    fontSize: 8,
    // type: 'CURVE_SMOOTH',
    fontWeight: 'normal',
    highlightColor: 'blue',
    highlightFontSize: 8,
    highlightFontWeight: 'normal',
    labelProperty: 'label',
    mouseCursor: 'pointer',
    opacity: 1,
    renderLabel: false,
    semanticStrokeWidth: false,
    strokeWidth: 2
  }
};
// fixes eslint warning about missin display name
TASK_GRAPH_CONFIG.node.viewGenerator.displayName = 'TaskNode';

export default TASK_GRAPH_CONFIG;
